import React from 'react';
import ProducteursArticles from './producteursArticles';
// import UserConnect from './userConnect';

import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux"
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';
import { NavLink, useParams } from "react-router-dom";
import { USER_INIT, ARTICLE_INIT } from '../constants/globals';
import { insertArticle, updateArticle } from '../actions/actions-types';
import ImageUpload from './imageUpload';


const Articles = (props) => {
    const { userCJ } = useSelector(state => state);
    const { postId } = useParams();
    const dispatch = useDispatch();
    const [producteurs, setProducteurs] = useState([]);
    const [fiche, setFiche] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState([]);
    const [articles, setArticles] = useState([]);
    const [filtre, setFiltre] = useState([]);
    const [maj, setMaj] = useState(false);
    const [showAdd, setShowAdd] = useState(true);
    const [showUpdateImg, setShowUpdateImg] = useState([]);

    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);

    useEffect(() => {
        fetch(`${URL_COURTJUS_BACK}/producteurs`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                setProducteurs(res);
            });
    }, []);

    useEffect(() => {
        const articles = [];
        articles.push(ARTICLE_INIT);
        setArticles(articles);
    }, []);

    useEffect(() => {
        setFiche(false);
    }, []);

    useEffect(() => {
        setSelectedProduct(USER_INIT);
    }, []);


    const handleChange = (event) => {
        event.preventDefault();
        const { value } = event.target;
        setFiltre(value);
    };

    const ClickAddVoir = () => {
        setShowAdd(true);
    }
    const ClickAddCacher = () => {
        setShowAdd(false);
    }

    const handleFiltre = (event) => {
        event.preventDefault();
        fetch(`${URL_COURTJUS_BACK}/producteurs/${filtre}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                setProducteurs(res);
            });
    };

    const filteredProducteurs = postId
        ? producteurs.filter(q => q.uNum == postId)
        : producteurs;

    function findIndex(idStr) {
        const idArray = idStr.split('_');
        return Number(idArray[1]);
    };

    function euros(NumValue) {
        const retour = Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(NumValue,);
        return retour;
    };
    function unitemesure(UnitNb, Mesure) {
        let retour = '';
        let mesureTxt = Mesure
        let nombreTxt = UnitNb
        if (UnitNb > 1 && Mesure !== 'Colis') { mesureTxt = mesureTxt + 's' }
        let femminin = ['Pièce', 'Demie Pièce', 'Bouteille']
        if (UnitNb === 1 && femminin.includes(Mesure)) { nombreTxt = 'la ' }
        if (UnitNb === 1 && !femminin.includes(Mesure)) { nombreTxt = 'le ' }
        if (UnitNb > 1) { nombreTxt = 'les ' + UnitNb }
        retour = nombreTxt + " " + mesureTxt
        return retour;
    };

    const handleChangeArticle = (event) => {
        event.preventDefault();
        const { id, name, value } = event.target;
        const articlesChange = [...articles];
        articlesChange[findIndex(id)][name] = value;
        articlesChange[findIndex(id)].aMsg = "";
        setArticles(articlesChange);
    };

    const handleNewArticle = (event) => {
        event.preventDefault();
        const { id } = event.target;
        const articlesChange = [...articles];
        const newArticle = ARTICLE_INIT;
        newArticle.aNumProducteur = findIndex(id);
        newArticle.aMsg = "";
        articlesChange.push(newArticle);
        setArticles(articlesChange);
        ClickAddCacher()
    };

    let secuUpdate = true;
    if ((selectedProduct.uNum === userCJ.uNum && userCJ.uProducteur) || userCJ.uAdmin) { secuUpdate = false };

    const handleView = (event) => {
        const { name } = event.target;
        fetch(`${URL_COURTJUS_BACK}/users/${name}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                if (res === null) {
                    setSelectedProduct(USER_INIT);
                } else {
                    setSelectedProduct(res[0]);
                    fetch(`${URL_COURTJUS_BACK}/articles/${res[0].uNum}`)
                        .then(response => response.json())
                        .then(resA => {
                            const aNums = resA.map(article => ({
                                aNum: article.aNum,
                                value: false
                            }));
                            setShowUpdateImg(aNums);
                            setArticles(resA);
                            setFiche(true);
                        });
                }
            });
        ClickAddVoir()
    };

    const handleHide = (event) => {
        setFiche(false);
        if (maj) {
            setMaj(false);
            handleFiltre();
        }
    };

    const handleSubmit = (event) => {
        const { id } = event.target;
        const actArticle = articles[findIndex(id)]
        let errMsg = "";
        if (actArticle.aLibelle.length < 6) {
            errMsg = "Le libellé de l'article est trop court (6 car) !";
        };
        if (actArticle.aMesure.length < 2) {
            errMsg = "Le libellé de l'article est trop court (2 car) !";
        };
        if (isNaN(actArticle.aUnitNb)) {
            errMsg = "le nombre par lot n'est pas valide";
        };
        if (isNaN(actArticle.aUnitPrice)) {
            errMsg = "le prix n'est pas valide";
        };
        if (errMsg) {
            const articlesChange = [...articles];
            articlesChange[findIndex(id)].aMsg = errMsg;
            setArticles(articlesChange);
        };
        if (!errMsg) {
            if (actArticle.aNum === 0) {
                // Ajout d'un article
                dispatch(insertArticle({ actArticle }));
                errMsg = "Article Ajouté !";
                setTimeout(() => {
                    fetch(`${URL_COURTJUS_BACK}/articles/${selectedProduct.uNum}`, {
                        method: 'GET',
                        headers: headers,
                    })
                        .then(response => response.json())
                        .then(resA => {
                            setArticles(resA);
                        });
                }, 2000);
            } else {
                // Modification d'un article
                dispatch(updateArticle({ actArticle }));
                errMsg = "Informations mises à jour !";
            }
            const articlesChange = [...articles];
            articlesChange[findIndex(id)].aMsg = errMsg;
            setArticles(articlesChange);
            toggleShowUpdateImg(actArticle.aNum, false)
        }
        setMaj(true);
        ClickAddVoir()
        event.preventDefault();
    };


    const handleDelete = (event, index) => {
        const { id } = event.target;
        const actArticle = articles[findIndex(id)]
        let errMsg = "";
        if (actArticle.aNum > 0) {
            actArticle.aNumProducteur = -Math.abs(actArticle.aNumProducteur);
            dispatch(updateArticle({ actArticle }));
            errMsg = "Informations mises à jour !";
            const articlesChange = [...articles];
            articlesChange[findIndex(id)].aMsg = errMsg;
            setArticles(articlesChange);
            setMaj(true);
        }
        event.preventDefault();
    };

    const checkANumValue = (aNum) => {
        const foundItem = showUpdateImg.find(item => item.aNum === aNum);
        return foundItem ? foundItem.value : null;
    };

    const toggleShowUpdateImg = (aNum, valeur) => {
        setShowUpdateImg(prevState =>
            prevState.map(item =>
                item.aNum === aNum ? { ...item, value: valeur } : item
            )
        );
    };

    const handleUploadStatusUpdate = (fileName, aNum, index) => {
        if (fileName != 'error') {
            console.log(fileName, aNum)

            const articlesChange = [...articles];
            articlesChange[index] = {
                ...articlesChange[index],
                aPhoto: fileName,
                aMsg: ""
            };
            setArticles(articlesChange);

            setShowUpdateImg(prevState =>
                prevState.map(item =>
                    item.aNum === aNum ? { ...item, value: false } : item
                )
            );
        }

    };


    return (
        <main className="container">
            <div className="main-down"></div>
            {/* {userMenu===true && <UserNav />} */}
            {/* {userMenu===true && <UserConnect />} */}
            <h3>Les producteurs - leurs articles</h3>
            <section className="nav-admin">
                <form method="POST" id="formFiltre" className='form-filtre' onSubmit={handleFiltre}>
                    <input type="text" name="filtre" id="filtre" value={filtre} onChange={handleChange} />
                    <NavLink aria-label="Filtrer" title="Filtrer" onClick={handleFiltre}><img name={`Filtrer`} className={'btn-articles'} src="/img/search.png" width={'26px'} height={'26px'} alt="Filtrer" /></NavLink>
                </form>
            </section>
            <div className="saut"></div>
            {filteredProducteurs.map((q, i) =>
                <section className="section-prods section-auto" key={i}>
                    <NavLink aria-label="voir les articles" title="voir les articles" onClick={handleView}><img name={`${q.uNum}`} className={'btn-articles'} src="/img/list.png" width={'48px'} alt="Voir les articles" /></NavLink>
                    <article className="section-prods-fiche">
                        <h2>{q.uStructure} <span className="p-impact">{q.uProduction}</span></h2>

                        <h3>{q.uPrenom} {q.uNom}</h3>
                        <p>{q.uMailPro && q.uMailPro}{q.uMailPro === "" && q.uMail} - {q.uTel}</p>
                        <div className="btn-detail">
                        </div>
                    </article>
                    <ProducteursArticles uNum={q.uNum} />
                </section>
            )}
            {fiche &&
                <div className='zone-fiche-fixed'>
                    <article>
                        <h2><NavLink aria-label="masquer les articles" title="masquer les articles" onClick={handleHide}><img className="btn-retour" src="/img/retour.png" alt="retour à la liste" /></NavLink>
                            {selectedProduct.uStructure} <span className="p-impact">{selectedProduct.uProduction}</span></h2>

                        <h3>{selectedProduct.uPrenom} {selectedProduct.uNom}</h3>
                        <p>{selectedProduct.uMailPro && selectedProduct.uMailPro}{selectedProduct.uMailPro === "" && selectedProduct.uMail} - {selectedProduct.uTel} - {selectedProduct.uAdr_CP} {selectedProduct.uAdr_Ville}</p>
                        <div className="btn-detail">
                        </div>
                    </article>
                    <article className="section-prods-infos form-fiche">
                        <fieldset>
                            <legend>Produits à la vente</legend>
                            {selectedProduct.uNum == postId &&
                                <div className="form-zone">
                                    <p className="p-impact fond-plus-soustitre"><i className="fa-solid fa-triangle-exclamation"></i>&nbsp;&nbsp;&nbsp;&nbsp; N'oubliez pas d'enregistrer chaque articles après modification<br />
                                        <i className="fa-regular fa-message"></i>&nbsp;&nbsp;&nbsp;&nbsp; Vous pouvez me joindre sur contact.awa05.ovh si besoin</p>
                                </div>}
                            {articles
                                .sort((a, b) => a.aLibelleIni.localeCompare(b.aLibelleIni)) // Trier les articles par aLibelle
                                .map((q, i) => (

                                    <div key={i} >
                                        {!secuUpdate &&
                                            <form method="POST" id={`form_${i}`} disabled={secuUpdate} onSubmit={handleSubmit} >
                                                <div className={`form-zone form-zone-${secuUpdate && 'disabled'} ${q.aNum === 0 && 'section-prods-new'} form-flex`}>
                                                    {checkANumValue(q.aNum) &&
                                                        <div className='form-zone'>
                                                            <p className='p-impact'>Choisir une nouvelle image</p>
                                                            <ImageUpload
                                                                userId={`a${q.aNum}`}
                                                                onUploadStatusUpdate={(fileName) => handleUploadStatusUpdate(fileName, q.aNum, i)}
                                                            />
                                                        </div>
                                                    }
                                                    {q.aNum > 0 && !checkANumValue(q.aNum) &&
                                                        // retirer zone-ordi-masque à la V2 'Gestion des images des articles'
                                                        <img
                                                            src={q.aPhoto ? `/img/pictures/${q.aPhoto}` : '/img/pictures/articles_defaut.png'}
                                                            alt="la vue de l'article"
                                                            className="float-prods form-img-small form-img zone-masque"
                                                            onClick={() => toggleShowUpdateImg(q.aNum, true)}
                                                        />
                                                    }
                                                    <div></div>
                                                    <div className='zone-max'>
                                                        {q.aMsg && <section className="section-prods-err"><p>{q.aMsg}</p></section>}
                                                        <p>
                                                            <input type="hidden" name="aIndex" id={`aIndex_${i}`} value={i} disabled={secuUpdate} />
                                                            <input type="hidden" name="aNumProducteur" id={`aNumProducteur_${i}`} value={q.aNumProducteur} disabled={secuUpdate} />
                                                            <input type="hidden" name="aNum" id={`aNum_${i}`} value={q.aNum} disabled={secuUpdate} />
                                                            <label htmlFor={`aLibelle_${i}`}> Libellé : &nbsp;</label>
                                                            <input className="input-dbl" type="text" name="aLibelle" id={`aLibelle_${i}`} required value={q.aLibelle} onChange={handleChangeArticle} disabled={secuUpdate} />
                                                        </p>
                                                        <p>
                                                            <label htmlFor={`aStockIni_${i}`}> Stock initial :&nbsp;</label>
                                                            <input className="input-small" type="number" maxLength="5" name="aStockIni" id={`aStockIni_${i}`} required value={q.aStockIni} onChange={handleChangeArticle} disabled={secuUpdate} />
                                                            <label htmlFor={`aUnitNb_${i}`}>&nbsp;en lot de :&nbsp;</label>
                                                            <input className="input-small" type="number" maxLength="5" name="aUnitNb" id={`aUnitNb_${i}`} required value={q.aUnitNb} onChange={handleChangeArticle} disabled={secuUpdate} />
                                                            <label htmlFor={`aMesure_${i}`}>&nbsp;</label>
                                                            <select className="input-default input-list" type="text" maxLength="6" name="aMesure" id={`aMesure_${i}`} required value={q.aMesure} onChange={handleChangeArticle} disabled={secuUpdate} >
                                                                <option value={q.aMesure}>{q.aMesure}</option>
                                                                <option value="" disabled>---------------</option>
                                                                <option value="Pièce">Pièce</option>
                                                                <option value="Demie Pièce">Demie Pièce</option>
                                                                <option value="Kilo">Kilo</option>
                                                                <option value="Gramme">Gramme</option>
                                                                <option value="Milligramme">Milligramme</option>
                                                                <option value="Colis">Colis</option>
                                                                <option value="Bouteille">Bouteille</option>
                                                                <option value="Litre">Litre</option>
                                                                <option value="Centilitre">Centilitre</option>
                                                                <option value="Millilitre">Millilitre</option>
                                                            </select>
                                                            <label htmlFor={`aUnitPrice_${i}`}>&nbsp; prix : &nbsp;</label>
                                                            <input className="input-small" type="number" maxLength="5" name="aUnitPrice" id={`aUnitPrice_${i}`} required value={q.aUnitPrice} onChange={handleChangeArticle} disabled={secuUpdate} />
                                                        </p>
                                                        <p>
                                                            <label htmlFor={`aPrecision_${i}`}> Précision : &nbsp;</label>
                                                            <input className="input-max" type="text" name="aPrecision" id={`aPrecision_${i}`} value={q.aPrecision} onChange={handleChangeArticle} disabled={secuUpdate} />
                                                        </p>
                                                        <p style={{ display: 'none' }}>
                                                            <label htmlFor={`aComment_${i}`}> Commentaires : &nbsp;</label>
                                                            <input className="input-max" type="text" name="aComment" id={`aComment_${i}`} value={q.aComment} onChange={handleChangeArticle} disabled={secuUpdate} />
                                                        </p>
                                                        {!secuUpdate &&
                                                            <p>
                                                                {q.aNum === 0 && <span className='section-prods-alert'>Attention : l'article sera automatiquement trié dés son enregistrement</span>}
                                                                <button id={`sav_${i}`} disabled={secuUpdate} className='btn btn-primary'>Enregistrer
                                                                    {q.aNum === 0 && " le nouvel article"}
                                                                </button>
                                                                {userCJ.uAdmin &&
                                                                    <button id={`del_${i}`} disabled={secuUpdate} className='btn btn-danger' title='Supprimer l article' onClick={(e) => handleDelete(e, i)}>Supp
                                                                    </button>}
                                                            </p>
                                                        }
                                                    </div>
                                                </div>
                                            </form>
                                        }
                                        {secuUpdate &&
                                            <div className={`form-zone form-zone-${secuUpdate && 'disabled'} form-flex`}>
                                                <img
                                                    src={q.aPhoto ? `/img/pictures/${q.aPhoto}` : '/img/pictures/articles_defaut.png'}
                                                    alt="la vue de l'article"
                                                    className="float-prods form-img-small zone-masque"
                                                />
                                                <div></div>
                                                <div className='zone-max'>
                                                    {q.aMsg && <section className="section-prods-err"><p>{q.aMsg}</p></section>}
                                                    <p>
                                                        <span className="zone-fiche-span p-impact">{q.aLibelle}</span>
                                                        <span className="zone-fiche-span-bold">{euros(q.aUnitPrice)}</span>
                                                        {unitemesure(q.aUnitNb, q.aMesure)}</p><p>
                                                        <span className="zone-fiche-span-bold">[{q.aStockIni} à la vente]</span>
                                                    </p>
                                                    <p>{q.aPrecision.length > 0 && 'Précision :'} {q.aPrecision}</p>
                                                    <p style={{ display: 'none' }}> {q.aComment} </p>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                ))}
                            {!secuUpdate &&
                                <div className="form-zone">
                                    {showAdd &&
                                        <form method="POST" id={`form_New`} >
                                            <p><button id={`new_${selectedProduct.uNum}`} className='btn btn-light' onClick={handleNewArticle}>Ajouter un nouvel Article</button></p>
                                        </form>
                                    }
                                </div>
                            }
                        </fieldset>
                    </article>
                    <article>
                        <h2><NavLink aria-label="masquer les articles" title="masquer les articles" onClick={handleHide}><img className="btn-retour" src="/img/retour.png" alt="retour à la liste" /></NavLink></h2>
                    </article>
                </div>
            }
            <div className="main-down"></div>

        </main>

    )
}

export default Articles;